var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex flex-column flex-column-fluid"},[_c('div',{staticClass:"app-content flex-column-fluid",staticStyle:{"background":"#F9F9F9"},attrs:{"id":"kt_app_content"}},[_c('div',{staticClass:"app-container container-fluid",attrs:{"id":"kt_app_content_container"}},[_c('div',[_vm._t("default")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }